export default __webpack_public_path__ + "static/media/tvBackground.54c498d7.png";